import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Payments({ children }) {
  useInjectSaga({ key: 'settingsPayments', saga });
  useInjectReducer({ key: 'settingsPayments', reducer });

  return React.Children.only(children);
}

Payments.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withPayments } from './withPayments';
export default compose(withConnect, memo)(Payments);
